import { render } from "./object-fit.md?vue&type=template&id=00b82561"
const script = {}
script.render = render

export default script